import { h, render } from 'preact'
import Modal from './components/Modal'
import PrivacySettingsLink from './components/PrivacySettingsLink'
import { StateProvider } from './context/Context';

// Create a new element to insert the entire UI into
const footerSelector = window.$mediavine.web.model.footer_selector
const targetSelector: HTMLElement = footerSelector && document.querySelector(footerSelector) || document.body
const preactRoot = document.createElement('div')

preactRoot.setAttribute('data-name', 'mediavine-gdpr-button')
targetSelector.insertAdjacentElement('beforeend', preactRoot)

render (
  <StateProvider>
    <Modal />
    <PrivacySettingsLink />
  </StateProvider>,
  preactRoot,
)
